import { render } from "./QueryDetailsForm.vue?vue&type=template&id=5f90f7ab"
import script from "./QueryDetailsForm.vue?vue&type=script&lang=js"
export * from "./QueryDetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3586\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__